<div class="row row-cols-1 row-cols-md-5">
	<div class="col mb-4" *ngFor="let item of listBook" [routerLink]=" item.routerLink" [queryParams]="item.queryParams">
		<div class="card h-100">
			<img [src]="getCdnImage(item.url)" class="card-img-top" [style.background-image]="'url(' + getCdnImage(item.background) + ')'"
				style="padding:20px;">
			<div class="card-body">
				<h5 class="card-title">{{ item.category }}</h5>
				<p class="card-text">{{ item.info }}</p>
				<!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
			</div>
		</div>
	</div>
</div>

<!-- <div class="carousel slide">
  <div class="row">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let item of listBook" [routerLink]=" item.routerLink" [queryParams]="item.queryParams">
      <div class="card" [style.background-image]="'url(' + item.background + ')'">
        <img class="card-img-top img-fluid" [src]="item.url" width="50" height="50" alt="Card image cap" />
        <div class="card-body">
          <div class="card-title">{{ item.category }}</div>
          <p class="card-text">{{ item.info }}</p>
        </div>
      </div>
    </div>
  </div>
</div> -->
